import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import {
  fetchPatientDownload,
  usePatientList,
} from "../../../../api/member-management/use-patient";
import Table from "../../../../components/ui/Table/Table";
import { formatDateTime } from "../../../../utils/format";
import { indexer } from "../../../../utils/utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total, handleDetail) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.name, {
      header: "환자명",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.citizenNo, {
      header: "주민등록번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.gender, {
      header: "성별",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? (val === "F" ? "여성" : "남성") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.contact, {
      header: "휴대전화 번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.address, {
      header: "주소",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? formatDateTime(val) : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.id, {
      header: "자세히보기",
      cell: (info) => {
        const id = info.getValue();
        return (
          <button
            type="button"
            onClick={() => handleDetail(id)}
            className="w-12 p-[1px] mx-2 border border-[#cccccc] rounded-[4px] text-[#333333]"
          >
            상세
          </button>
        );
      },
    }),
  ];
};

const HospitalPatientTable = (props) => {
  const { filter, hospitalId } = props;
  const { isEmpty, getDataTableProps } = usePatientList({
    ...filter,
    hospitalId,
  });
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll || getDataTableProps().total;
  const navigate = useNavigate();

  const handleDetail = (id) => {
    navigate(`/patient/${id}`);
  };

  const onSave = async () => {
    const response = await fetchPatientDownload({
      ...filter,
      hospitalId,
    });
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `hospital-patients-${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  if (isEmpty) {
    return (
      <div className="flex justify-center mt-[140px] text-[#999999] text-center text-[14px]">
        등록된 내역이 없습니다.
      </div>
    );
  }

  return (
    <Table
      hasSave
      onSave={onSave}
      hasPageSizeFilter={false}
      hasSort={false}
      columns={columns(currentPage, pageSize, totalData, handleDetail)}
      {...getDataTableProps()}
    />
  );
};

export default HospitalPatientTable;
